var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.5C23.1042 1.5 24 2.38184 24 3.46875V17.9062C24 18.9932 23.1042 19.875 22 19.875H2C0.895833 19.875 0 18.9932 0 17.9062V3.46875C0 2.38184 0.895833 1.5 2 1.5H22ZM11.8066 13.873L11.5811 13.9668C11.1964 14.2012 11.0762 14.7013 11.3125 15.0859C11.551 15.4733 12.0546 15.5951 12.4395 15.3604L12.6924 15.1221L15.6514 12.293L11.8066 13.873ZM7.28613 7.23145C4.71466 8.81706 3 11.6575 3 14.9004H6.57422C6.62282 13.0147 7.63483 11.3688 9.13477 10.4346L7.28613 7.23145ZM14.8574 10.4287C16.363 11.3601 17.3772 13.0119 17.4258 14.9004H21C21 11.6547 19.283 8.81127 16.7061 7.22852L14.8574 10.4287ZM12 5.90039C10.4745 5.90039 9.04039 6.27987 7.7832 6.94824L9.63379 10.1572C10.348 9.80857 11.1515 9.61426 12 9.61426C12.8456 9.61426 13.6432 9.80852 14.3574 10.1543L16.209 6.94336C14.9548 6.27754 13.5199 5.9004 12 5.90039Z",
    fill: "#212737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.970a5249ea278e4881e3899bfd4d8826.svg";
export { ForwardRef as ReactComponent };